import _ from 'static/script/libs/underscore';
import Storage from 'static/script/app/data/storage-service';

let ItemsClickStorage = function () {
    this.maxNoOfItems = 200;
    this.timeToLive = 60 * 60 * 1000;
    this._storage = new Storage('items-click');

    this._removeOld();
};

ItemsClickStorage.prototype._removeOld = function () {
    // TODO: Clean old ones
};


ItemsClickStorage.prototype.get = function (itemId) {
    return this._storage.get(itemId);
};

ItemsClickStorage.prototype.getSearchId = function (itemId) {
    // TODO: Check that it isnt too old
    let item = this._storage.get(itemId);

    if (item) {
        return JSON.parse(item).searchId;
    }
    return false;
};

ItemsClickStorage.prototype.add = function (payload) {
    this._storage.remove(payload.itemId);

    return this._storage.set(
        payload.itemId,
        JSON.stringify({
            searchId: payload.searchId
        }));
};

export default ItemsClickStorage;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/models/items-click-storage.js